import React, { useContext, useState } from "react";
import { StyledNotification, StyledPotentialGainBackground } from "../../dashboard.style";
import GainSum from "./GainSum";
import NotificationInner from "../notificationSubComponents/NotificationInner";
import PotentialGainBackground from "./PotentialGainBackground";
import FixelDataContext from "../../../../context/FixelDataContext";
import { gainContent } from "../generateNotificationContent";

const PotentialGain = () => {
  const [show, setShow] = useState(true);
  const { fullFixelData } = useContext(FixelDataContext);
  if (show) {
    return (
      <div>
        <StyledNotification type="gain">
          <StyledPotentialGainBackground>
            <PotentialGainBackground />
          </StyledPotentialGainBackground>
          <NotificationInner type="gain" content={gainContent()} CTA={() => setShow(false)} />
          <GainSum sum={fullFixelData.conversions.potentialRevenue} />
        </StyledNotification>
      </div>
    );
  } else return null;
};
export default PotentialGain;
